import { useMediaQuery, useTheme } from '@mui/material';
import type { Breakpoint } from '@mui/material';

/**
 * useThemeMediaQuery hook
 * Custom hook for responsive breakpoints
 */
export default function useThemeMediaQuery(
	breakpoint: Breakpoint | number | ((theme: any) => string) = 'lg',
	direction: 'up' | 'down' = 'down',
) {
	const theme = useTheme();

	if (typeof breakpoint === 'function') {
		const query = breakpoint(theme);
		return useMediaQuery(query);
	}

	const query =
		typeof breakpoint === 'number'
			? `(${direction === 'up' ? 'min' : 'max'}-width:${breakpoint}px)`
			: direction === 'up'
				? theme.breakpoints.up(breakpoint)
				: theme.breakpoints.down(breakpoint);

	return useMediaQuery(query);
}
